<template>
  <component :is="layout">
    <router-view/>
  </component>
</template>

<script lang="ts">
import Vue from "vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

export default Vue.extend({
  name: "App",
  computed: {
    layout() {
      return this.$route.meta!.layout || DefaultLayout;
    }
  }
});
</script>